import React, { useCallback, useEffect, useState } from "react";
import { Typography, Button } from "@mui/material";
import BasicTable from "../Table/Material";
import useApi from "../../Hooks/useApi";
import { usePagination } from "../../Hooks/usePagination";
import useWindowHeight from "../../Hooks/useWindowHeight";


const KIICityListModal = ({ kii }) => {
  const { kiiId, kiiName } = kii;


  const { request, loading } = useApi();
  const [kiiCityData, setKiiCityData] = useState();
  const paginateProps = usePagination();

  const columns = [
    {
      id: "name",
      label: "City Name",
      minWidth: 170,
    },
    {
      id: "type",
      label: "City Type",
      minWidth: 170,
      renderCell: (row) => <>{row.type.replace("_", " ")}</>,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 100,
    },
    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align: "center",
      renderCell: (row) => (
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            // Handle view details action
        
          }}
        >
          Remove
        </Button>
      ),
    },
  ];

  const fetchKiiCities = useCallback(async () => {
    try {
      const response = await request(
        "GET",
        `/v1/kii/city-mapping/${kiiId}`,
        {},
        "kii_service"
      );
      setKiiCityData(response.cities);
    } catch (error) {
      console.log(error);
    }
  }, [request, kiiId]);

  useEffect(() => {
    fetchKiiCities();
  }, [fetchKiiCities]);



  const windowHeight = useWindowHeight();

  return (
    <div className="relative h-full">
      <div className="flex items-center justify-between">
        <Typography
          variant="h4"
          sx={{ textAlign: "center" ,
            fontSize: { xs: "1.25rem", sm: "1.50rem", md: "1.75rem", lg: "2rem" }
          }}
          className="w-full py-4"
        >
          Manage KII City List - {kiiName}
        </Typography>
      </div>

      {kiiCityData && kiiCityData.length && !loading ? (
    
         <BasicTable
          style={{ width: "90%", marginRight: "auto", marginLeft: "auto" }}
          maxHeight={Math.max(windowHeight * 0.3, 100)}
          columns={columns}
          data={kiiCityData}
          paginateProps={paginateProps}
        />
   
      ) : (
        <div className="text-center text-lg">No city added</div>
      )}
    </div>
  );
};

export default KIICityListModal;
